export default {
  state: {
    visibility: false,
    loading: false,
    success: null
  },
  mutations: {
    INIT_LOAD_CALL_DIALOG(state) {
      state.visibility = true
      state.loading = true
    },
    RESET_LOAD_CALL_DIALOG(state) {
      state.visibility = false
    },
    RESET_LOAD_CALL_LOADING(state, payload) {
      state.loading = false
      state.success = payload
    }
  }
}
